import { toString } from '../utils/buffer';
import { decodeBytes, encodeBytes } from './bytes';
export const encodeString = (buffer, value) => {
  const bufferValue = Buffer.from(value, 'utf8');
  return encodeBytes(buffer, bufferValue, 'bytes');
};
export const decodeString = (value, buffer) => {
  return toString(decodeBytes(value, buffer, 'string'));
};
//# sourceMappingURL=string.js.map